import { isEmpty } from 'lodash';
import { CountryCode, Maybe } from '@csp/csp-common-model';
import { TechnicalSupportContentModel } from '@csp/csp-web-content-definitions';
import { TechnicalSupportEntry } from '../model/TechnicalSupportEntry';

const from = (content: TechnicalSupportContentModel, countryCode: CountryCode): TechnicalSupportEntry => {
  const countrySpefificDetails = content.contact_details?.find(contactDetail => {
    const contactDetailCountries = contactDetail.country?.country as Maybe<string[]>;

    return contactDetailCountries?.includes(countryCode.toUpperCase());
  });

  return {
    email: !isEmpty(countrySpefificDetails?.email) ? countrySpefificDetails?.email : content.email,
    phoneNumber: countrySpefificDetails?.phone_number,
  };
};

export const TechnicalSupportEntryMapper = {
  from,
};
